module.exports = __webpack_public_path__ + "static/img/bb3.7e4d08d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bb3.jpg
// module id = 3R8S
// module chunks = 1